import api from "../services/api";
import { asyncAction } from "./actions";

export const LABELS_FETCH = "LABELS_FETCH";

export const fetchLabels = (accessToken) =>
  asyncAction(LABELS_FETCH, api.labels.list(accessToken));
